import { render, staticRenderFns } from "./KpiPanel.vue?vue&type=template&id=bd700472&scoped=true"
import script from "./KpiPanel.vue?vue&type=script&lang=js"
export * from "./KpiPanel.vue?vue&type=script&lang=js"
import style0 from "./KpiPanel.vue?vue&type=style&index=0&id=bd700472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd700472",
  null
  
)

export default component.exports